// Pure onboarding step logic for the WhatsApp Tech Provider super-admin panel.
// Mirrors the backend STEPS order (conversations-service/lib/waOnboarding/state.js).
//
// 'triage' and 'number_pending' are the self-serve wizard's PRE-connect steps, inserted 2026-09-02
// to match the backend. They were added at the FRONT on purpose: whatsappSelfStart.js derives its
// in-progress band positionally (`slice(indexOf('waba_connected'), indexOf('live'))`), so anything
// inserted before that band leaves the customer tab's four states exactly as they were. Append or
// reorder inside the waba_connected→live tail and you change what the customer tab shows.
export const STEPS = ['not_started','triage','number_pending','number_ready','link_sent','waba_connected','sender_registered','template_submitted','live'];

const LABELS = {
  not_started: 'Not started',
  // Wizard-owned steps: the practice is answering questions / waiting on a number. The operator
  // panel stays the manual override, but there is no operator ACTION at these two (see nextAction).
  triage: 'In the self-serve wizard — number questions answered',
  number_pending: 'Handed to our team — number still to sort out',
  number_ready: 'Number ready',
  link_sent: 'Connect link sent — awaiting customer',
  waba_connected: 'WhatsApp account connected',
  sender_registered: 'Sender registered',
  template_submitted: 'Reminder template added',
  live: 'Live',
};
export function stepLabel(step) {
  return LABELS[step] || 'Unknown';
}
export function progressPercent(state) {
  const i = STEPS.indexOf(state && state.step);
  return i < 0 ? 0 : Math.round((i / (STEPS.length - 1)) * 100);
}
/**
 * Turn a failed /wa-onboarding/* call into an operator-facing message.
 *
 * 401/403 became REAL outcomes on 2026-07-21, when the admin endpoints gained a genuine
 * server-side super-admin check (previously the only gate was this panel being hidden). An
 * operator seeing "Failed to register sender" when the actual cause is an expired session has
 * no path forward, so those two cases get their own text; everything else keeps the caller's
 * specific fallback.
 */
export function failureMessage(err, fallback) {
  const code = err && err.response && err.response.status;
  if (code === 401) return 'Your session has expired. Please sign in again.';
  if (code === 403) return 'Your account is not authorized for WhatsApp onboarding.';
  return fallback;
}

// Returns { key, label } — key drives which operator button is highlighted.
export function nextAction(state) {
  const step = state && state.step;
  switch (step) {
    // The wizard owns these two. `initMySelfStart` 409s on them (WIZARD_OWNED_STEPS), so offering
    // "generate & send connect link" here would hand the operator a button the backend refuses.
    // The 'wizard' key matches no action block in the panel, which is the point: label only.
    case 'triage':
    case 'number_pending':
      return { key: 'wizard', label: 'Practice is in the self-serve wizard — no operator action yet' };
    case 'link_sent': return { key: 'awaiting', label: 'Waiting for customer to connect (resend link if needed)' };
    case 'waba_connected': return { key: 'register', label: 'Register WhatsApp sender' };
    case 'sender_registered': return { key: 'template', label: 'Add reminder template' };
    case 'template_submitted': return { key: 'enable', label: 'Enable WhatsApp for this site' };
    case 'live': return { key: 'done', label: 'WhatsApp is live' };
    default: return { key: 'init', label: 'Generate & send connect link' }; // not_started / number_ready / unknown
  }
}
